import { render } from "./ModalImportMedicine.vue?vue&type=template&id=2b85cb15&scoped=true"
import script from "./ModalImportMedicine.vue?vue&type=script&lang=js"
export * from "./ModalImportMedicine.vue?vue&type=script&lang=js"

import "./ModalImportMedicine.vue?vue&type=style&index=0&id=2b85cb15&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b85cb15"]])

export default __exports__